import { CreateAddressDTO, AssertUrl } from './models'
import { DEFAULT_PAGE_SIZE } from '@/constants'
import AddressBaseApi from './base'
import {
  ReceiveAddressGroupItem,
  GetFirstReceiveAddressGroupDTO,
  GetGroupAddressListDTO,
  AddressListPageModel,
} from './models'

class AddressApi extends AddressBaseApi {
  async getFirstReceiveAddressGroup(dto: GetFirstReceiveAddressGroupDTO) {
    return this.post<ReceiveAddressGroupItem>('/getFirstGroupAddress', dto)
  }
  async getGroupAddressList(dto: GetGroupAddressListDTO) {
    return this.post<AddressListPageModel>('/getGroupAddressList', {
      pageSize: DEFAULT_PAGE_SIZE,
      ...dto,
    })
  }
  async createAddress(dto: CreateAddressDTO) {
    return this.post<string>('/createAddress', dto)
  }
  async getAssertUrlList() {
    return this.post<AssertUrl[]>('/getAssertUrlList')
  }
}

export default new AddressApi()
